import React from 'react';
import Commons from '../../commons/Commons';
import FromServer from './FromServer';
import AppBar from '../../commons/AppBar'
import SpecificComponent from '../../commons/SpecificComponent';
import UseriList from '../../commons/UseriList'
import AddUser from '../../commons/dialogs/AddUser'
import { Fab } from '@material-ui/core';


export default class Useri extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
            listUsers:[],
            strEmail:'',
            strNumeUser:'',
            isOpenInsert:false
        }
    }

     componentDidMount(){
         this.fromServer()
    }

    fromServer = async () =>{
        let fs = new FromServer();

       let users = await fs.getUsersAll()

    //    console.log('users :', users);

       let usersIds = [...new Set(users.map(i=>i.id))]

       let usersUnique =[]

       for(let i=0, n = usersIds.length; i < n; i++ ){
           let idx = users.findIndex(u => u.id === usersIds[i])

           usersUnique.push(users[idx])
       }

       this.setState({listUsers:usersUnique})
    }
    

    userClick = (e) =>{
        // console.log('e :', e);

        this.props.history.push(`/infouser/${e.id}`)
    }


 

    insertUser = async() =>{

        let fs = new FromServer();

       let  objToInsert = {
            nume:this.state.strNumeUser,
            email:this.state.strEmail,
            telefon:''
        }

        let insert = await fs.insertUser(objToInsert)
// console.log('insert :', insert);
        if(insert.ok){


             this.props.history.push(`/infouser/${insert.content[0].id}`)
        }

    }

  
     render() { 
       return (
          <div>
              <AppBar
                    history={this.props.history}
                    title={this.dictionary.appBar.drawer.users}
                />
                 <div className='container'>
                 {/* <Fab  onClick={()=>{this.setState({isOpenInsert:true})}} className="pm-round-button">
                                      <i className='material-icons pm-round-button-text'>add</i>
                            </Fab> */}
                <UseriList
                    elemente={this.state.listUsers}
                    dict={this.dictionary}
                    onlyColumns={{nume:'nume'}}
                    onElClick={this.userClick}
                    />
                </div>
                <AddUser    
                    open={this.state.isOpenInsert}
                    dialogClose={()=>{this.setState({isOpenInsert:false})}}
                    title={this.dictionary.appBar.buttons.insertUser}    
                    limba={this.dictionary}
                    strNumeUser={this.state.strNumeUser}
                    numeChange={(ev)=>{this.setState({strNumeUser:ev.target.value})}}
                    strEmail={this.state.strEmail}
                    emailChange={(ev)=>{this.setState({strEmail:ev.target.value})}}
                    addUser={this.insertUser}
                    />


         </div>
        );
       }
}